export type MessengerSettingsSectionId =
  | 'profile'
  | 'avatar'
  | 'notifications'
  | 'privacy'
  | 'interface'
  | 'security'
  | 'storage';

export type MyProfileForm = {
  first_name: string;
  last_name: string;
  middle_name: string;
  bio: string;
  phone: string;
  position: string;
  organization: string;
  website: string;
  github_username: string;
  telegram_username: string;
  work_time: string;
};

export type MessengerSettingsSection = {
  id: MessengerSettingsSectionId;
  icon: string;
  label: string;
  desc: string;
};

export const MESSENGER_SETTINGS_SECTIONS: readonly MessengerSettingsSection[] = [
  { id: 'profile', icon: '👤', label: 'Профиль', desc: 'Фото, имя' },
  { id: 'avatar', icon: '✨', label: 'Эффекты аватара', desc: 'Цвет, свечение' },
  { id: 'notifications', icon: '🔔', label: 'Уведомления', desc: 'Push, превью' },
  { id: 'privacy', icon: '🔒', label: 'Приватность', desc: 'Прочтения, блок' },
  { id: 'interface', icon: '🎨', label: 'Интерфейс', desc: 'Шрифт, плотность' },
  { id: 'security', icon: '🛡️', label: 'Безопасность', desc: 'Сессии' },
  { id: 'storage', icon: '💾', label: 'Кэш', desc: 'Память и файлы' },
] as const;

export const DEFAULT_MY_PROFILE_FORM: MyProfileForm = {
  first_name: '',
  last_name: '',
  middle_name: '',
  bio: '',
  phone: '',
  position: '',
  organization: '',
  website: '',
  github_username: '',
  telegram_username: '',
  work_time: '',
};

export function getSettingsSectionMeta(sectionId: MessengerSettingsSectionId): MessengerSettingsSection {
  return MESSENGER_SETTINGS_SECTIONS.find((section) => section.id === sectionId) || MESSENGER_SETTINGS_SECTIONS[0];
}

export function getSettingsSectionTitle(sectionId: MessengerSettingsSectionId): string {
  const section = getSettingsSectionMeta(sectionId);
  return section.label;
}
